"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Regions = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Region = require("./Region");
const _excluded = ["regions"];
const Regions = _ref => {
  let {
      regions
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, regions && regions.map((region, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: `region-${region.id}-${index}`
  }, /*#__PURE__*/_react.default.createElement(_Region.Region, (0, _extends2.default)({
    region: region
  }, rest)))));
};
exports.Regions = Regions;